import { RootState } from "index";
import { useSelector } from "react-redux";

interface HasPermission {
  (permission: string): boolean;
}

const useHasPermission = (): HasPermission => {
  const user: { permissions?: string[] } | null = useSelector((state: RootState) => state?.Login?.user);

  const hasPermission = (permission: string): boolean => {
    return user?.permissions?.includes(permission) ?? false;
  };

  return hasPermission;
};

export default useHasPermission;
